export const LINE_NAMES = {
  MAX: 'maxData',
  AVG: 'avgData',
  MIN: 'minData',
  ESTIMATED: 'estimatedData',
  PERCENTILE: 'percentileData',
  PERCENTILE99: 'percentile99Data',
  REQUEST: 'request',
};
